import { t } from 'i18next';
import { FullProg_v4 } from '~/providers/types';

export const ecoModeCfgs: { [k: string]: string } = {
  'eco-D': t('desligar'),
  'eco-V': t('ventilar'),
  'eco-C1-V': t('desligarCondensadora2DepoisVentilar'),
  'eco-C2-V': t('desligarCondensadora1DepoisVentilar'),
};

export const DEFAULT_DAM_FULL_PROG: FullProg_v4 = {
  week: {
  },
  ventTime: {
    begin: 0,
    end: 0,
  },
  exceptions: {
  },
};
